import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import NewsletterModal from '../../components/Common/Modal/NewsletterModal'

export default function OnboardingModalManager() {
  const [showNewsletter, setShowNewsletter] = useState(false)
  const location = useLocation()

  useEffect(() => {
    let timer;
    const checkNewsletterPopup = () => {
      try {
        const email = localStorage.getItem('userEmail') || 'guest'
        const hasSeenNewsletter = localStorage.getItem(`has_seen_newsletter_popup_${email}`) === 'true'
        const token = localStorage.getItem('authToken')

        // Define paths where we DON'T want to show the popup (auth pages)
        const authPaths = ['/login', '/register', '/forgot-password', '/logout', '/pages-login', '/pages-register']
        const isAuthPage = authPaths.some(path => location.pathname.startsWith(path))

        // Don't show if user is currently in the initial AI/Chatbot onboarding flow
        const isInitialOnboarding = location.pathname === '/chatbot' && location.state?.initialPrompt;

        // only show modal when user is authenticated and not on an auth page and hasn't seen it yet
        if (!hasSeenNewsletter && token && !isAuthPage && !isInitialOnboarding) {
          // Delay for better UX
          timer = setTimeout(() => setShowNewsletter(true), 3000)
        }
      } catch (e) {
        console.error("Error checking newsletter popup status:", e)
      }
    }

    checkNewsletterPopup()
    return () => {
      if (timer) clearTimeout(timer)
    }
  }, [location.pathname, location.state])

  const closeNewsletter = () => {
    setShowNewsletter(false)
  }

  return (
    <>
      <NewsletterModal
        show={showNewsletter}
        handleClose={closeNewsletter}
      />
    </>
  )
}
